module.exports = __webpack_public_path__ + "img/abimg8.7c2845ed.png";